import * as React from 'react';

import { ProductLabelModel } from '@notino/react-styleguide';
import { IStock } from '@notino/shared/definitions/custom-definitions';
import { VariantDisplayType } from '@notino/shared/definitions/types';

import { getGiftCampaigns } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/Gift';
import { GiftLabel } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/SelectedVariant/GiftLabel';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useDisplayType } from '@containers/ProductDetailContainer/utils';

import { giftLabel, ITagsProps } from './model';
import { StyledLabel } from './styled';
import { useCornerTags } from './useCornerTags';

export const CornerTag: React.FC<ITagsProps> = ({
  stockAvailability,
  onClick,
  attributes,
}) => {
  const { product, currentVariant } = useProductDetailContext();

  const displayType = useDisplayType(product);

  const isColorPicker = displayType === VariantDisplayType.ColorPicker;

  const tagAttribute = useCornerTags({
    attributes,
    isColorPicker,
  });

  if (stockAvailability === IStock.outOfStock) {
    return null;
  }

  const { hasGiftCampaigns } = getGiftCampaigns({
    product,
    variant: currentVariant,
  });

  const shouldShowGiftLabel =
    hasGiftCampaigns && !tagAttribute && !isColorPicker;

  return (
    <>
      {tagAttribute && (
        <StyledLabel
          key={tagAttribute.attribute}
          labelStyle={tagAttribute.style}
          icon={tagAttribute.icon}
          labelType={ProductLabelModel.Types.corner}
          className={`pd-variant-tag-${tagAttribute.attribute}`}
          onClick={() => onClick?.(tagAttribute.attribute)}
        >
          {tagAttribute.attribute}
        </StyledLabel>
      )}

      {shouldShowGiftLabel && (
        <GiftLabel
          labelType={ProductLabelModel.Types.corner}
          icon={giftLabel.icon}
        />
      )}
    </>
  );
};
